import { render, staticRenderFns } from "./FormDetailsDesktopView.vue?vue&type=template&id=f676fc38"
import script from "./FormDetailsDesktopView.vue?vue&type=script&lang=js"
export * from "./FormDetailsDesktopView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports